module.exports = __webpack_public_path__ + "static/img/logo.2d38ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/model/Images/logo.png
// module id = Tnev
// module chunks = 1